import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './plugins/element.js';
// 导入字体图标
import './assets/fonts/iconfont.css';
// 导入全局样式表
import './assets/css/global.css';

import TreeTable from 'vue-table-with-tree-grid';

import axios from 'axios';
// 配置请求的跟路径
//  axios.defaults.baseURL = 'http://localhost:8089/'
axios.defaults.baseURL = 'https://api.llts.com.cn/';
// axios.defaults.baseURL = 'https://www.llts.com.cn/'
// axios.defaults.baseURL = 'http://ting.v5time.net/'

axios.interceptors.request.use((config) => {
  // console.log(config)
  // config.headers.Authorization = window.sessionStorage.getItem('token')
  // 在最后必须 return config
  return config;
});
Vue.prototype.$http = axios;

Vue.config.productionTip = false;

Vue.component('tree-table', TreeTable);

Vue.filter('dateFormat', function (originVal) {
  const dt = new Date(originVal);

  const y = dt.getFullYear();
  const m = (dt.getMonth() + 1 + '').padStart(2, '0');
  const d = (dt.getDate() + '').padStart(2, '0');

  const hh = (dt.getHours() + '').padStart(2, '0');
  const mm = (dt.getMinutes() + '').padStart(2, '0');
  const ss = (dt.getSeconds() + '').padStart(2, '0');

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
